<template>
    <div>
        <el-form ref="form" :model="context" :rules="rules" v-if="mode==='edit' || mode === 'add'" :inline="true">
            <el-form-item label="事業區" prop="business_district">
                <el-select 
                    v-model="context.business_district" 
                    placeholder="事業區"
                    @change="val=>inner_handle_dynamic_form_update('business_district', val, index)"
                >
                    <el-option
                    v-for="item in all_districts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="林班" prop="forest_squad">
                <el-input 
                    v-model="context.forest_squad" 
                    placeholder='三位數編號'
                    @change="val=>inner_handle_dynamic_form_update('forest_squad', val, index)"
                ></el-input>
            </el-form-item>
            <el-button @click="remove_data(index)" icon="el-icon-delete" />
        </el-form>
        <div v-else>
            <span>{{context.business_district}}&nbsp;{{context.forest_squad}}林班</span>
        </div>
    </div>
</template>

<script>

//事業區;林班
//   一組多值
//   事業區: (文山事業區|宜蘭事業區|羅東事業區|太平山事業區|南澳事業區|和平事業區|大溪事業區)
//   林班:三位數編號
//   詳目頁欄位顯示為[Ａ事業區ＢＢＢ林班]

// 保安林

export default {
    components: {
    },
    props: ['mode','handle_dynamic_form_update','preloaded_data','preloaded_data_update_flag','index','remove_data'],
    data() {
      return {
          all_districts: ['文山事業區','宜蘭事業區','羅東事業區','太平山事業區','南澳事業區','和平事業區','大溪事業區'].map(x=>{return{label:x, value:x}}),
          context:{
            business_district: null,
            forest_squad: '',
          },
          rules: {
            business_district: [
                { required: true, message: '必填', trigger: 'change' }
            ],
            forest_squad: [
                { required: true, message: '必填', trigger: 'change' },
                { pattern: /^[0-9]+$/, message: '必須為數字', trigger: 'change'},
                { len:3, message: '長度必須為3', trigger: 'change' }
            ],
          }
      }
    },
    watch: {
        preloaded_data_update_flag: function () {
            this.update_form(this.preloaded_data)
            this.validate_form()
        },
        preloaded_data: function (data) {
            this.update_form(data)
            this.validate_form()
        }
    },
    created: function () {
        console.log('ForestryMultiValueFields::created(): preloaded_data:', this.preloaded_data)
        this.update_form(this.preloaded_data)
    },
    methods: {
        update_form (preloaded_data) {
            console.log('ForestryMultiValueFields: update_form: preloaded_data:', preloaded_data)

            if (this.preloaded_data) {
                this.context.business_district = preloaded_data['business_district']
                this.context.forest_squad = preloaded_data['forest_squad']
            }

            this.validate_form()
        },
        validate_form (){
            if (this.$refs['form']) {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit('update-valid', true)
                    } else {
                        console.log('ForestryMultiValueFields: validation failed')
                        this.$emit('update-valid', false)
                    }
                })
            }
        },
        inner_handle_dynamic_form_update (key, val, index) {
            this.validate_form()

            if (this.handle_dynamic_form_update) {
                this.handle_dynamic_form_update(key, JSON.parse(JSON.stringify(val)), index)
            }
        },
    }
  };
</script>

<style>
</style>
